import { useQuery } from "@tanstack/react-query";
import { LocationFragment } from "./fragments/location";
import { setState, useLocationId } from "~/store";
import {
	GetCurrentLocationDocument,
	GetCurrentLocationQuery,
} from "~/types/__generated/gql/graphql";
import { validateSessionFromUrl } from "~/utils/validate-session-from-url";
import { gqlReq } from "~/libs/gql";
import { queryClient } from "~/providers/query-provider";

void (
	/* GraphQL */ `
		query GetCurrentLocation {
			getCurrentLocation {
				...LocationFragment
			}
		}
		${LocationFragment}
	`
);

export const getCurrentLocationQueryKey = () => ["location"];

export const useGetCurrentLocation = () => {
	const locationId = useLocationId();

	return useQuery({
		enabled: !!locationId,
		queryKey: getCurrentLocationQueryKey(),
		queryFn: ({ signal }) => {
			const { isSessionExpired, isPathnameSessionSensitive } =
				validateSessionFromUrl();
			if ((isPathnameSessionSensitive() && isSessionExpired()) || !locationId)
				return Promise.resolve(undefined);
			return gqlReq({
				document: GetCurrentLocationDocument,
				signal,
			});
		},
		onSuccess: (data) => {
			if (!data) return;
			setState({ locationId: data._id, venueId: data.venue });
		},
	});
};

export const getCurrentLocationCache = () => {
	return queryClient.getQueryData<GqlResultOf<GetCurrentLocationQuery>>(
		getCurrentLocationQueryKey(),
	);
};
